import React from 'react'
import IconBase from '../IconBase'

const svgContent = <svg viewBox="0 0 1024 1024" width="1em" height="1em" focusable="false" fill="currentColor" aria-hidden="true"><path d="M646.059 166.443a42.667 42.667 0 1 0-60.331 60.373l149.76 149.76H170.667a42.667 42.667 0 0 0 0 85.333h667.861a42.667 42.667 0 0 0 30.165-72.832L646.06 166.443zm-476.886 398.89a42.539 42.539 0 0 1 16.299-3.242h667.861a42.667 42.667 0 1 1 0 85.333H288.512l149.76 149.76a42.667 42.667 0 0 1-60.33 60.416L155.306 634.88a42.581 42.581 0 0 1 13.866-69.59z" /></svg>

const Switch = React.forwardRef((props, ref) => {
  return (
    <IconBase name="switch" {...props} ref={ref}>
      {svgContent}
    </IconBase>
  )
})

Switch.displayName = 'IconSwitch'

export default Switch
